import { useMaestroStore } from '../store/maestroStore';
import { deviceStopAllowed, type DeviceStopOptions } from './transportStopGate';

/** Full transport stop — tears down RAAT session (iOS/Tauri native stop); clears stream + stopped state. */
export async function stop(rendererId?: string, stopOpts?: DeviceStopOptions): Promise<void> {
  const opts = deviceStopAllowed(stopOpts ?? { caller: 'unlabeled_transport_stop', userInitiated: false });
  if (!opts) return;
  const { markUserTransportStop } = await import('./remoteAdvanceControl');
  markUserTransportStop();
  const store = useMaestroStore.getState();
  const id = rendererId ?? store.activeConnectorRenderer?.id;
  if (!id) return;
  const priorPlaybackState = store.playbackState;
  const stoppedTrack = store.currentTrack?.title || store.currentTrack?.id || '(unknown)';
  console.log('[Transport] stop requested, clearing active URI — track was:', stoppedTrack, 'renderer:', id);
  try {
    const { TransportCommand } = await import('./TransportCommand');
    await TransportCommand.stopRenderer(id, opts);
    store.setRendererHasStream(false);
    store.clearStreamCache();
    store.setPlaybackState('stopped');
  } catch (err: unknown) {
    console.error('[Transport] stop failed — leaving playback UI unchanged:', err);
    if (priorPlaybackState === 'playing' || priorPlaybackState === 'loading' || priorPlaybackState === 'paused') {
      store.setPlaybackState(priorPlaybackState);
    }
  }
}
